<template>
    <div v-if="dateModal.isVisible">
        <div class="overlay" @click="closeModal"></div>
        <div class="modal-container">
            <div class="modal-body">{{ dateModal.text }}</div>

            <div class="vue-calendar">
                <VDatePicker v-model="date" transparent borderless :color="'orange'" :disabled-dates="disabledDates"/>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'DateModal',
    props: ['initialDate', 'disableDates'], // caso seja true, desabilita as datas do modal para o usuario conseguir selecionar um intervalo de 1 mes entre as datas inicial e final
    components: {
    },
    data () {
        return {
            date: new Date(),
            disabledDates: []
        }
    },
    computed: {
        ...mapGetters(['dateModal'])
    },
    methods: {
        ...mapActions(['closeDateModal']),
        closeModal () {
            this.closeDateModal()
            this.$emit('closeModal', this.date)
        }
    },
    watch: {
        disableDates (val) {
            if (val) {
                const iniDate = new Date(this.initialDate.split('/').reverse().join('-'))
                this.disabledDates = [
                    {
                        start: null,
                        end: iniDate
                    },
                    {
                        start: new Date(iniDate.getFullYear(), iniDate.getMonth() + 1, iniDate.getDate()),
                        end: null
                    }
                ]
            } else {
                this.disabledDates = []
            }
        },
        // fechar modal quando seleciona data
        date (val) {
            this.closeModal()
        }
    }
}
</script>

<style lang="less" scoped>
.modal-container {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto 30px;
    border-radius: 10px;
    z-index: 3;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
    background-color: white;
    height: max-content;
    display: flex;
    flex-direction: column;
    align-items: center;
    .modal-body {
        margin-top: 20px;
        margin-bottom: 10px;
    }

    .vue-calendar :deep(.vc-header) {
        button {
            background: none;
        }
    }
}

@media (min-width: 769px) {
  .modal-container {
    width: 50%;
    margin: auto;
  }
}

.overlay {
    position: fixed;
    top: 0; left: 0;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.21);
    z-index: 2;
}

</style>
